"use strict";

export { default } from './Pressable';
//# sourceMappingURL=index.js.map